import React from "react";
import FottServiceRequestContainer from "@features/terminal-services/fott-services/FottServiceRequestContainer";

const FottServiceRequestPage: React.FC = () => {
  return <FottServiceRequestContainer />;
};

export default FottServiceRequestPage;
